export default "__VITE_ASSET__Dol5EEXz__"